import type { CachedCompany, TargetOrganizationsSlice } from "./slice";

export function uniqueIds(ids: string[]): string[] {
  return Array.from(new Set(ids));
}

export function getActiveIds(slice: TargetOrganizationsSlice): string[] {
  const ids =
    slice.hgIdsIncludingCorporateRelatives.length > 0
      ? slice.hgIdsIncludingCorporateRelatives
      : slice.hgIds;
  return uniqueIds(ids);
}

export function buildCacheFromResults(
  ids: string[],
  companies: CachedCompany[] | undefined
): CachedCompany[] {
  if (!companies || companies.length === 0) return [];
  const byId = new Map(companies.map((c) => [c.hgId, c]));
  return ids.map((id) => byId.get(id)).filter((c): c is CachedCompany => !!c);
}
